/**
 * eBook Card Component
 * Displays a single eBook with cover image, title, description, and download button
 */

import React, { useState, useEffect } from 'react';
import { getDownloadStats } from '../api';

const EbookCard = ({ ebook, onDownloadClick, refreshStats }) => {
  const [downloadCount, setDownloadCount] = useState(0);
  const [loadingStats, setLoadingStats] = useState(false);

  // Fetch download statistics when component mounts
  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoadingStats(true);
        const response = await getDownloadStats(ebook.id);
        console.log('Stats response:', response);
        setDownloadCount(response.data.totalDownloads);
      } catch (error) {
        console.log('Could not fetch stats:', error);
      } finally {
        setLoadingStats(false);
      }
    };

    fetchStats();
  }, [ebook.id, refreshStats]);

  return (
    <div className="ebook-card">
      {/* eBook Cover Image */}
      <img
        src={ebook.imageUrl}
        alt={ebook.title}
        className="ebook-image"
        onError={(e) => {
          // Fallback if image fails to load
          // e.target.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
          e.target.style.display = 'none';
        }}
      />

      {/* eBook Content */}
      <div className="ebook-content">
        {/* Title */}
        <h3 className="ebook-title">{ebook.title}</h3>

        {/* Description */}
        <p className="ebook-description">{ebook.description}</p>

        {/* Statistics */}
        <div className="ebook-stats">
          📊 {loadingStats ? 'Loading...' : `${downloadCount} downloads`}
        </div>

        {/* Download Button */}
        <button
          className="btn"
          onClick={() => onDownloadClick(ebook)}
          title="Download this eBook"
        >
          📥 Download Now
        </button>
      </div>
    </div>
  );
};

export default EbookCard;
